import selectItemTypeDialogTemplate from "./selectItemTypeDialog.template.html";

/*******************************************************************************
 * Service: SelectItemTypeDialog
 *
 * Displays a dialog that allows the user to select the type of item to be added.
 *******************************************************************************/
/* @ngInject */ export function SelectItemTypeDialogService($uibModal, SERVER, BooksSvc) {
  /*****************************************************************************
   * show */
  /**
   * This will display a modal dialog that allows the user to select the type of
   * item to be created.
   *
   * @param  types  List of ItemType values.
   * @return        Promise to listen on
   *****************************************************************************/
  this.show = function (types) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: SelectItemTypeController,
      size: 'sm',
      template: selectItemTypeDialogTemplate,
      resolve: {
        types: function () {
          return types;
        }
      }
    }).result;
  };

  /** Dialog Controller. */
  var SelectItemTypeController = function ($scope, types) {
    /***************************************************************************
     * Constants
     ***************************************************************************/
    /** Default list of item types and labels. Used for filtering item types.
     * The order in which the appear affect the way they options will be
     * displayed to the user. */
    var DEFAULT_TYPE_LIST = [
      { ID: SERVER.BooksDBConstants.IT_MEMBERSHIP, Type: 'Membership' },
      { ID: SERVER.BooksDBConstants.IT_FINES, Type: 'Fine' },
      { ID: SERVER.BooksDBConstants.IT_PRODUCT, Type: 'Product' },
      { ID: SERVER.BooksDBConstants.IT_EQUIPMENT, Type: 'Equipment' },
      { ID: SERVER.BooksDBConstants.IT_GROUP, Type: 'Kit' },
      { ID: SERVER.BooksDBConstants.IT_TEXTBOOKS, Type: 'Textbook' },
      { ID: SERVER.BooksDBConstants.IT_DONATION, Type: 'Donation' },
      { ID: SERVER.BooksDBConstants.IT_RECORDS, Type: 'Record' },
      { ID: SERVER.BooksDBConstants.IT_FEES, Type: 'Fee' }
    ];

    /***************************************************************************
     * init */
    /**
     * Get the list of types to display. If none provided, display the default
     * list.
     ***************************************************************************/
    var init = function () {
      var setTypes = function (data) {
        /*-----------------------------------*/
        /* If selected item types is null or */
        /* empty, use the default type list. */
        /*-----------------------------------*/
        if (!data || data.length == 0) $scope.dpItems = DEFAULT_TYPE_LIST;
        /*-----------------------------------------------*/
        /* If types has been provided filter the         */
        /* default type list to match the types provided */
        /*-----------------------------------------------*/ else {
          $scope.dpItems = DEFAULT_TYPE_LIST.filter(function (t) {
            return data.indexOf(t.ID) != -1;
          });
        }

        /*-------------------------------*/
        /* Clear any default selections. */
        /*-------------------------------*/
        $scope.data = { selectedType: null };
      };

      if (types && types.length) setTypes(types);
      else
        BooksSvc.getWebConstants('selectItemTypes').then(function (resp) {
          setTypes(resp.data);
        });
    };

    /***************************************************************************
     * selectItemType */
    /**
     * Closes the modal and resolves with the type selected. Handler for the Ok
     * button.
     ***************************************************************************/
    $scope.selectItemType = function () {
      $scope.$close($scope.data.selectedType);
    };

    /*--------------------*/
    /* Initialize dialog. */
    /*--------------------*/
    init();
  };
}
